import { UseCase } from "../../useCase"
import { DeleteSurveySectionResponse } from "./response"
import { DeleteSurveySectionRequest } from "./request"
import { SurveyRepository } from "../../../repositories/surveyRepository"

export class DeleteSurveySectionUseCase implements UseCase<DeleteSurveySectionRequest, DeleteSurveySectionResponse> {
	private _repository
	constructor({ SurveyRepository }: { SurveyRepository: SurveyRepository }) {
		this._repository = SurveyRepository
	}

	exec(id: DeleteSurveySectionRequest) {
		return this._repository.deleteSurveySection(id)
	}
}
